import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const MinimalCloseRegAcc = ({ values, settings }) => {
  const { t } = useTranslation();

  return values.closeRegPayments ? (
    <TableContainer>
      <Table sx={{ minWidth: { md: "450px", xs: "300px" } }} size="small">
        <TableBody>
          <TableRow>
            <TableCell className="fw-5 gray-color tx-upp fs-italic">
              <span className="border-left fw-6">{t("paymentSummery")}</span>
            </TableCell>
            <TableCell
              align="right"
              className="fs-16 fw-6 gray-color"
            ></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="gray-color tx-upp">
              {t("registerOpeningBalance")}
            </TableCell>
            <TableCell align="right" className="fs-16 gray-color">
              {settings.curSymbol}{" "}
              {(values?.openingBalance || 0).toFixed(settings.decimal)}
            </TableCell>
          </TableRow>

          {values?.closeRegPayments.map((p, ind) => (
            <TableRow key={ind}>
              <TableCell className="gray-color tx-upp">
                {p.payMethodName} {t("sales")}
              </TableCell>
              <TableCell align="right" className="fs-16 gray-color">
                {settings.curSymbol}{" "}
                {(p?.totalAmount || 0).toFixed(settings.decimal)}
              </TableCell>
            </TableRow>
          ))}

          {values?.totalCreditSale > 0 && (
            <TableRow>
              <TableCell className="error-color tx-upp">
                {t("creditSale")} ({t("due")})
              </TableCell>
              <TableCell align="right" className="fs-16 error-color">
                (-) {settings.curSymbol}{" "}
                {(values?.totalCreditSale || 0).toFixed(settings.decimal)}
              </TableCell>
            </TableRow>
          )}

          <TableRow>
            <TableCell className="fw-5 gray-color tx-upp">
              <span className="fs-italic fw-6 border-left">
                {t("grandTotal")}
              </span>
            </TableCell>
            <TableCell
              align="right"
              className="fs-16 fw-6 gray-color"
            ></TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="fw-6 gray-color tx-upp">
              {t("totalCashInDrawer")}
            </TableCell>
            <TableCell align="right" className="fs-16 fw-6 gray-color">
              {settings.curSymbol}{" "}
              {(values?.totalCashInDrawer || 0).toFixed(settings.decimal)}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="fw-6 gray-color tx-upp">
              {t("totalOtherPayments")}
            </TableCell>
            <TableCell align="right" className="fs-16 fw-6 gray-color">
              {settings.curSymbol}{" "}
              {(values.totalOtherPayments || 0).toFixed(settings.decimal)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    "Loading..."
  );
};

export default MinimalCloseRegAcc;
